import CryptoJS from "crypto-js";

export const decryptSasUri = (cipherText) => {
  if (typeof cipherText !== "string" || !cipherText) {
    return "";
  }
  const key = process.env.REACT_APP_FILE_KEY;
  const iv = process.env.REACT_APP_FILE_IVV;
  try {
    const bytes = CryptoJS.AES.decrypt(cipherText, CryptoJS.enc.Utf8.parse(key), {
      iv: CryptoJS.enc.Utf8.parse(iv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch {
    return "";
  }
};
